//#region src/integration_instance_type.ts
var IntegrationInstanceType = /* @__PURE__ */ function(IntegrationInstanceType) {
	IntegrationInstanceType[IntegrationInstanceType["Sandbox"] = 1] = "Sandbox";
	IntegrationInstanceType[IntegrationInstanceType["Prod"] = 2] = "Prod";
	return IntegrationInstanceType;
}(IntegrationInstanceType || {});
//#endregion
export { IntegrationInstanceType };

//# sourceMappingURL=integration_instance_type.js.map